import { render } from "./upload.vue?vue&type=template&id=40a011cf&ts=true"
import script from "./upload.vue?vue&type=script&lang=tsx"
export * from "./upload.vue?vue&type=script&lang=tsx"

import "./upload.vue?vue&type=style&index=0&id=40a011cf&lang=less"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__